import { render, staticRenderFns } from "./property-type.vue?vue&type=template&id=2cf52b50&scoped=true&lang=html&"
import script from "./property-type.vue?vue&type=script&lang=js&"
export * from "./property-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf52b50",
  null
  
)

export default component.exports